module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/november-dd7ab6e77f684dcad801a9f56d71cfe1.png";